<div class="bar-chart-container">
  <div class="eliso-card-title">{{ titleText }}</div>
  @if (data !== undefined) {
    <div echarts [options]="chartOptions()"></div>
    <!-- <dx-chart
      [dataSource]="dataSource()"
      [rotated]="false"
      [palette]="colorPalette"
    >
      <dxo-legend
        [visible]="true"
        verticalAlignment="bottom"
        horizontalAlignment="center"
        itemTextPosition="right"
        [margin]="2"
      ></dxo-legend>
      <dxo-export [enabled]="false"></dxo-export>
      <dxo-common-series-settings
        type="bar"
        argumentField="arg"
        [valueField]="valueField"
      >
        <dxo-label
          [visible]="true"
          [format]="{
            type: 'fixedPoint',
            precision: precision,
          }"
        >
        </dxo-label>
      </dxo-common-series-settings>
      <dxo-series-template nameField="category"></dxo-series-template>
      <dxo-argument-axis
        ><dxo-label [visible]="false"></dxo-label
      ></dxo-argument-axis>
      @if (visualRange()) {
        <dxi-value-axis [visualRange]="visualRange()"></dxi-value-axis>
      }
      <dxo-tooltip [enabled]="false" [customizeTooltip]="customizeTooltip">
      </dxo-tooltip>
    </dx-chart> -->
  }
</div>
